import {
  keepPreviousData,
  useQuery,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { productsApi } from "@/api/products/products-api";
import type {
  ProductCreate,
  ProductUpdate,
} from "@/types/products/api-types/product-types";

interface ProductSearchParams {
  page?: number;
  size?: number;
  name?: string;
  category_name?: string;
  brand_name?: string;
  active_only?: boolean;
}

export const useGetProductsPaginated = (params: ProductSearchParams = {}) => {
  return useQuery({
    queryKey: ["products", params],
    queryFn: () => productsApi.getAll(params),
    placeholderData: keepPreviousData,
  });
};

export const useCreateProduct = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: ProductCreate) => productsApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["products"] });
    },
  });
};

export const useUpdateProduct = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: ProductUpdate }) =>
      productsApi.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["products"] });
    },
  });
};

export const useDeleteProduct = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => productsApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["products"] });
    },
  });
};
